module.exports = __webpack_public_path__ + "img/im_scrollfeature_01.5831bd80.jpg";